import { defineMessages } from 'react-intl';

export const esignRedirectTabMessages = defineMessages({
  title: {
    id: 'EsignRedirectTab.title',
    defaultMessage: 'Loading e-signature package',
    description:
      'Title shown in the new browser tab while connecting to an e-signature provider',
  },
  message: {
    id: 'EsignRedirectTab.message',
    defaultMessage:
      'Please wait while we connect you to your e-signature provider. This may take a moment.',
    description:
      'Message shown in the new browser tab while connecting to an e-signature provider',
  },
});
